import React, { useState } from 'react';
import { usePolicy } from '../context/PolicyContext';
import './Form.css';

const CancelPolicy: React.FC = () => {
  const { getPolicy, cancelPolicy } = usePolicy();
  const [policyNumber, setPolicyNumber] = useState('');
  const [cancellationReason, setCancellationReason] = useState('');
  const [errors, setErrors] = useState<Record<string, string>>({});
  const [success, setSuccess] = useState(false);
  const [policyFound, setPolicyFound] = useState(false);

  const handlePolicyCheck = (e: React.FormEvent) => {
    e.preventDefault();
    setErrors({});
    setPolicyFound(false);

    if (!policyNumber.trim()) {
      setErrors({ policyNumber: 'Please enter a policy number' });
      return;
    }

    const policy = getPolicy(policyNumber.trim());
    if (policy) {
      if (policy.status === 'cancelled') {
        setErrors({ policyNumber: 'This policy is already cancelled' });
        return;
      }
      setPolicyFound(true);
    } else {
      setErrors({ policyNumber: 'Policy not found' });
    }
  };

  const handleCancel = (e: React.FormEvent) => {
    e.preventDefault();
    setErrors({});

    if (!cancellationReason.trim()) {
      setErrors({ cancellationReason: 'Cancellation reason is required' });
      return;
    }

    cancelPolicy(policyNumber.trim(), cancellationReason.trim());
    setSuccess(true);
    setPolicyNumber('');
    setCancellationReason('');
    setPolicyFound(false);

    setTimeout(() => setSuccess(false), 5000);
  };

  return (
    <div className="form-container">
      <h2>Cancel Insurance Policy</h2>

      {success && (
        <div className="success-message">
          Policy has been cancelled successfully!
        </div>
      )}

      {!policyFound ? (
        <form onSubmit={handlePolicyCheck} className="form">
          <div className="form-group">
            <label htmlFor="policyNumber">Policy Number *</label>
            <input
              type="text"
              id="policyNumber"
              name="policyNumber"
              value={policyNumber}
              onChange={(e) => setPolicyNumber(e.target.value)}
              placeholder="Enter policy number"
              className={errors.policyNumber ? 'error' : ''}
            />
            {errors.policyNumber && <span className="error-text">{errors.policyNumber}</span>}
          </div>

          <button type="submit" className="submit-button">Verify Policy</button>
        </form>
      ) : (
        <form onSubmit={handleCancel} className="form">
          <div className="form-group">
            <label htmlFor="policyNumber">Policy Number</label>
            <input
              type="text"
              id="policyNumber"
              name="policyNumber"
              value={policyNumber}
              disabled
              className="disabled-input"
            />
          </div>

          <div className="form-group">
            <label htmlFor="cancellationReason">Cancellation Reason *</label>
            <textarea
              id="cancellationReason"
              name="cancellationReason"
              value={cancellationReason}
              onChange={(e) => {
                setCancellationReason(e.target.value);
                if (errors.cancellationReason) {
                  setErrors({ ...errors, cancellationReason: '' });
                }
              }}
              rows={5}
              placeholder="Please provide a reason for cancellation..."
              className={errors.cancellationReason ? 'error' : ''}
            />
            {errors.cancellationReason && (
              <span className="error-text">{errors.cancellationReason}</span>
            )}
          </div>

          <div className="button-group">
            <button type="submit" className="submit-button danger">Confirm Cancellation</button>
            <button
              type="button"
              className="submit-button secondary"
              onClick={() => {
                setPolicyFound(false);
                setPolicyNumber('');
                setCancellationReason('');
              }}
            >
              Cancel
            </button>
          </div>
        </form>
      )}
    </div>
  );
};

export default CancelPolicy;


